import React, {useEffect} from "react";
import ProjectSummaryTable from "../../Components/Projects/ProjectSummaryTable";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
const Projects = () => {
    useEffect(() => {
        document.title = 'Projects - CPC';
    }, []);
  return (
      <div>
          <Grid container
                spacing={3}
                justifyContent='space-between'
          >
              <Grid size={{ xs: 5, sm: 8 }} sx={{
                  display: 'flex',
                  alignItems: 'center'}}>
                  <Typography variant="h2" sx={{
                      display: 'flex',
                      alignItems: 'center'}}>Projects</Typography>
              </Grid>
              <Grid size={{ xs: 7, sm: 4 }} sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: {xs: 'right', sm: 'right'}}}
              >
                  <Link to="/projects/new">
                      <Button variant="contained" color="primary">New Project</Button>
                  </Link>
              </Grid>
              <Grid size={{ xs: 12 }} >
                  <ProjectSummaryTable />
              </Grid>
          </Grid>
      </div>
  )
};

export default Projects;